module.exports = __webpack_public_path__ + "img/GALERIA-CIAZ-2021-4.81bd26c0.jpg";